import {Space} from "antd";
import {
  CreateProductOfferingFormGroups,
  EditProductOfferingFormGroups,
} from "../accordion/data";
import {applyOfferingFormFeatureFlags} from "../accordion/apply-feature-flags-to-form-groups";
import {OfferingFormAccordionItem} from "../accordion/accordion-item";
import {ProductOfferingFormProps} from "./types";
import {ProductSettingsFormFields} from "./settings";
import {RedirectAfterPurchaseFormFields} from "../session-bundle/session/redirect-after-purchase";

export function CreateProductOfferingForm({
  isGeneralInformationError,
  isPricingError,
  isSettingsError,
}: ProductOfferingFormProps) {
  return (
    <Space direction="vertical" size={16} style={{display: "flex"}}>
      {applyOfferingFormFeatureFlags(CreateProductOfferingFormGroups).map((fg, index) => {
        if (fg.title === "General information") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isGeneralInformationError}
            >
              {fg.children}
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Pricing") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isPricingError}
            >
              {fg.children}
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Email automation") {
          return (
            <OfferingFormAccordionItem key={fg.title} index={index} title={fg.title}>
              {fg.children}
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Settings") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isSettingsError}
            >
              <ProductSettingsFormFields showUrlRedirect={false} />
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Redirect after purchase") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isSettingsError}
            >
              <RedirectAfterPurchaseFormFields />
            </OfferingFormAccordionItem>
          );
        } else {
          return null;
        }
      })}
    </Space>
  );
}
export function EditProductOfferingForm({
  isGeneralInformationError,
  isPricingError,
  isSettingsError,
  isCoverImagesError,
}: ProductOfferingFormProps) {
  return (
    <Space direction="vertical" size={16} style={{display: "flex"}}>
      {applyOfferingFormFeatureFlags(EditProductOfferingFormGroups).map((fg, index) => {
        if (fg.title === "General information") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isGeneralInformationError}
            >
              {fg.children}
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Cover image") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isCoverImagesError}
            >
              {fg.children}
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Pricing") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isPricingError}
            >
              {fg.children}
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Email automation") {
          return (
            <OfferingFormAccordionItem key={fg.title} index={index} title={fg.title}>
              {fg.children}
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Settings") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isSettingsError}
            >
              <ProductSettingsFormFields showUrlRedirect={false} />
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Redirect after purchase") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isSettingsError}
            >
              <RedirectAfterPurchaseFormFields />
            </OfferingFormAccordionItem>
          );
        } else {
          return null;
        }
      })}
    </Space>
  );
}
